import { forwardRef } from 'react';

export const BaseLineEdit = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 20.25H21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path
      d="M6.37741 11.8272C5.81558 12.3897 5.5 13.1522 5.5 13.9472V16.3457H7.91557C8.71145 16.3457 9.47471 16.0295 10.0374 15.4666L17.6749 7.82563C18.683 6.8171 18.683 5.18241 17.6749 4.17388V4.17388C16.6659 3.16445 15.0295 3.16476 14.0209 4.17457L6.37741 11.8272Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
));
